<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>退货查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运单号" prop="freightBillCode">
                <el-input v-model="searchform.freightBillCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发运单号" prop="outbill_code">
                <el-input v-model="searchform.outbill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="6">
              <el-form-item label="批次号" prop="batch_no">
                <el-input v-model="searchform.batch_no" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-select
                  v-model="searchform.productCode"
                  placeholder="请输入产品名称模糊匹配或者下拉选择"
                  style="width:100%"
                  :remote-method="getproductlist"
                  filterable
                  remote
                  :loading="productloading"
                  :disabled="show"
                >
                  <el-option
                    v-for="item in productlist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货单号" prop="rejected_orderno" >
               <el-input v-model="searchform.rejected_orderno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="箱码/盒码" prop="qrcode" >
               <el-input v-model="searchform.qrcode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="包装级别" prop="packageLevel">
                 <el-select
                  v-model="searchform.packageLevel"
                  style="width:100%"
                  clearable
                  placeholder="请选择包装级别"
                >
                  <el-option
                    v-for="item in packageLevel"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货时间" prop="datelist" >
                   <el-date-picker
                           style="width:100%"
                           v-model="searchform.datelist"
                           type="daterange"
                           value-format="yyyy-MM-dd HH:mm:ss"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>
            
            <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['refund_select']">搜索</el-button>
               <el-button
              v-permission="['refund_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>退货查询</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="rejected_orderno" label="退货单号"  min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freight_bill_code" label="运单号"  min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outbill_code" label="发运单号" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batch_no" label="批次号"  min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealer" label="客户" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品"  min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="箱码/盒码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="package_level" label="包装级别"  min-width="110"></el-table-column>
            <el-table-column prop="scan_time" label="扫码时间"  min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="退货时间"  min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="packing_proportion" label="退货数量"   min-width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="channel_type" label="退货渠道"   min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="rejected_order_type" label="退货类型"   min-width="100" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { productlist } from "@/api/base";
import { queryrejected } from "@/api/physical";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata({channelType:1});
    this.getproductlist();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
       //产品列表下拉
      productloading: false,
      show: false,
      productlist: [], 
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
       //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据
      channelType:[
        {
          value:0,
          label:"配送中心"
        },
        {
          value:1,
          label:"退货仓"
        }
      ],
      packageLevel:[
        {
          value:1,
          label:"一级包装"
        },
        {
          value:2,
          label:"二级包装"
        }
      ],
      searchform: {
        rejected_orderno:null,
        batch_no:null,
        outbill_code:null,
        freightBillCode: null,
        channelType:null,
        datelist:[],
        sscanTime : null,
        escanTime :null,
        packageLevel: null,
        productCode:null,
        enterprise_code:null,
        qrcode:null,
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
     // 获取产品下拉
    getproductlist(value) {
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            for (var i = 0; i < response.data.data.length; i++) {
              var option = {};
              option.value = response.data.data[i].product_code;
              option.label =
                response.data.data[i].product_code +
                "   " +
                response.data.data[i].product_name;
              this.productlist.push(option);
            }
            console.log(this.productlist);
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      queryrejected(obj).then(response => {
        this.getdate(response.data.list)
        this.tableData = response.data.list;
        this.currentPage = response.data.currPage;
        this.total_count = response.data.totalCount;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    getdate(obj){ // 拼装后台传的表格数据
      for (let i = 0; i < obj.length; i++) {
         obj[i].scan_time =  this.$parseTime(obj[i].scan_time);
         obj[i].address = obj[i].province_id + obj[i].city_id + obj[i].district_id;
         obj[i].product = (obj[i].product_code || ' ' ) + (obj[i].product_name || ' ' );
         obj[i].dealer = (obj[i].dealer_code || ' ' ) + (obj[i].dealer_name || ' ' );
         switch (obj[i].package_level) {
           case 1: obj[i].package_level = "一级包装"            
             break;
             case 2: obj[i].package_level = "二级包装"
             break;      
           default:
             break;
         };
         switch (obj[i].channel_type) {
           case 0: obj[i].channel_type = "配送中心"            
             break;
             case 1: obj[i].channel_type = "退货仓"
             break;      
           default:
             break;
         };
         switch (obj[i].rejected_order_type) {
           case 0: obj[i].rejected_order_type = "拒收退货"            
             break;
             case 2: obj[i].rejected_order_type = "销售退货"
             break;      
           default:
             break;
         };
        }
    },
    //搜索事件
    search() {
        this.Tabledata({
          rejected_orderno:this.searchform.rejected_orderno,
           batch_no:this.searchform.batch_no,
          outbill_code:this.searchform.outbill_code,
          qrcode: this.searchform.qrcode,
        freightBillCode: this.searchform.freightBillCode,
        screate_time : this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreate_time : this.searchform.datelist==null ? null:this.searchform.datelist[1],
        packageLevel: this.searchform.packageLevel,
        productCode:this.searchform.productCode,
        channelType:1,
        enterprise_code:this.searchform.enterprise_code,
        pageSize:this.searchform.pageSize
        });

    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
      this.Tabledata({
        rejected_orderno:this.searchform.rejected_orderno,
         batch_no:this.searchform.batch_no,
        outbill_code:this.searchform.outbill_code,
          qrcode: this.searchform.qrcode,
        freightBillCode: this.searchform.freightBillCode,
        screate_time : this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreate_time : this.searchform.datelist==null ? null:this.searchform.datelist[1],
        packageLevel: this.searchform.packageLevel,
        productCode:this.searchform.productCode,
        channelType:1,
        enterprise_code:this.searchform.enterprise_code,
        currPage:this.searchform.currPage,
        pageSize:this.searchform.pageSize
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
     this.search()
    },
            //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
          rejected_orderno:this.searchform.rejected_orderno,
           batch_no:this.searchform.batch_no,
          outbill_code:this.searchform.outbill_code,
          qrcode: this.searchform.qrcode,
        freightBillCode: this.searchform.freightBillCode,
        screate_time : this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreate_time : this.searchform.datelist==null ? null:this.searchform.datelist[1],
        packageLevel: this.searchform.packageLevel,
        productCode:this.searchform.productCode,
        channelType:1,
      };
      queryrejected(obj).then(response => {
        this.tableDataDownload = response.data.list;
        this.getdate(this.tableDataDownload)
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "退货单号",
            "运单号",
            "发运单号",
            "批次号",
            "客户",
            "产品",
            "箱码/盒码",
            "包装级别",
            "扫码时间",
            "退货时间",
           
            "退货数量",
            "退货渠道",
            "退货类型"
          ];
          const filterVal = [
             "rejected_orderno",
            "freight_bill_code",
            "outbill_code",
            "batch_no",
            "dealer",
            "product",
            "qrcode",
            "package_level",
            "scan_time",
            "create_time",
           
            "packing_proportion",
            "channel_type",
            "rejected_order_type"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>